import React from "react";
import { InputRangeRow } from "./index";
// Used by Heli KV2002 (Pirn) machine

export default function F1Row() {
   return (
      <InputRangeRow
         titleProp={"F1"}
         descriptionProp={"sec"}
         sizeProp={4}
         typeProp={"text"}
         minProp={0}
         maxProp={99} //some default value
         propertyNameProp={"f1"}
         errorDialogueProp={"0-99 only"}
         floatProp={false}
      />
   );
}
